var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalFullScreen",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "upgrade-modal-area" }, [
        _c("div", { staticClass: "info-icon" }, [_c("InfoIcon")], 1),
        _c("h3", [_vm._v("Upgrading Subscription Plan")]),
        _c("p", [
          _vm._v(
            " You are about to upgrade from the " +
              _vm._s(this?.activeSubscriptionPlan?.name) +
              " $" +
              _vm._s(Number(this?.activeSubscriptionPlan?.price) / 100) +
              "/mo to the " +
              _vm._s(this?.upgradingSubscriptionPlan?.name) +
              " $" +
              _vm._s(Number(this?.upgradingSubscriptionPlan?.price) / 100) +
              "/mo subscription. Would you like to proceed? "
          ),
        ]),
        _c(
          "div",
          { staticClass: "btns-wrap flex gap-2 justify-end" },
          [
            _c("UiButton", {
              attrs: {
                id: "cancelMessage",
                buttonText: "Not Now",
                variant: "outline",
                disabled: _vm.isLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
            _c("UiButton", {
              attrs: {
                buttonText: "Yes",
                processing: _vm.isLoading,
                id: "connfirm",
                buttonClass: "bg-black",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("confirmUpgrade")
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }